/**
 * Scoped styles for <headless-mailing>. Built only on the `--hm-*` theming API,
 * with neutral dark fallbacks so the element also stands alone. Square-ish
 * corners, hairline borders, slow eased motion, no emoji — sibling of
 * <headless-shop> / <headless-tryon>.
 */
export const STYLES = `
:host {
  --_bg: var(--hm-bg, transparent);
  --_ink: var(--hm-ink, #f7f1e6);
  --_muted: var(--hm-muted, #9a8f7b);
  --_line: var(--hm-hairline, #2a2723);
  --_field-bg: var(--hm-field-bg, rgba(255,255,255,.03));
  --_accent: var(--hm-accent, #be9a5c);
  --_accent-ink: var(--hm-accent-ink, #0b0b0a);
  --_err: var(--hm-error, #c97a6d);
  --_ok: var(--hm-success, #9bbf8f);
  --_font-body: var(--hm-font-body, Georgia, 'Times New Roman', serif);
  --_font-label: var(--hm-font-label, system-ui, sans-serif);
  --_corner: var(--hm-corner, 4px);
  --_gap: var(--hm-gap, 16px);
  --_tracking: var(--hm-label-tracking, 0.18em);
  display: block;
  background: var(--_bg);
  color: var(--_ink);
  font-family: var(--_font-body);
}
* { box-sizing: border-box; }
form { display: flex; flex-direction: column; gap: var(--_gap); margin: 0; }
.heading {
  font-family: var(--_font-label); font-size: 12px; letter-spacing: var(--_tracking);
  text-transform: uppercase; color: var(--_muted); margin: 0 0 4px;
}
.field { display: flex; flex-direction: column; gap: 6px; }
label {
  font-family: var(--_font-label); font-size: 10px; letter-spacing: var(--_tracking);
  text-transform: uppercase; color: var(--_muted);
}
input, textarea {
  font-family: var(--_font-body); font-size: 16px; color: var(--_ink);
  background: var(--_field-bg); border: 1px solid var(--_line); border-radius: var(--_corner);
  padding: 12px 14px; outline: none; width: 100%; resize: vertical;
  transition: border-color 240ms cubic-bezier(.22,1,.36,1);
}
input::placeholder, textarea::placeholder { color: var(--_muted); opacity: .7; }
input:focus-visible, textarea:focus-visible { border-color: var(--_accent); }
button {
  font-family: var(--_font-label); font-size: 11px; letter-spacing: var(--_tracking);
  text-transform: uppercase; cursor: pointer;
  color: var(--_accent-ink); background: var(--_accent);
  border: 1px solid var(--_accent); border-radius: var(--_corner);
  padding: 13px 22px;
  transition: opacity 240ms cubic-bezier(.22,1,.36,1);
}
button:hover { opacity: .88; }
button:disabled { opacity: .5; cursor: default; }
.note { font-family: var(--_font-label); font-size: 11px; letter-spacing: .04em; color: var(--_muted); margin: 0; }
.error { font-size: 14px; color: var(--_err); margin: 0; }
.success {
  border: 1px solid var(--_line); border-radius: var(--_corner);
  padding: 18px 20px; font-size: 17px;
}
.success strong { color: var(--_accent); font-weight: 600; }
/* Honeypot — hidden from humans, tempting to bots. Never use display:none
   (some bots skip invisible inputs); park it off-canvas instead. */
.hp {
  position: absolute; left: -9999px; width: 1px; height: 1px;
  opacity: 0; pointer-events: none;
}
`
